import ClearIcon from "@mui/icons-material/Clear";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import UploadIcon from "@mui/icons-material/Upload";
import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import React, { forwardRef } from "react";

const PlayerFileUpload = forwardRef((props, ref) => {
  const {
    title,
    open,
    Transition,
    onClose,
    onChange,
    clearFileInput,
    counterMovementList,
    counterMovementStation,
    handleCounterMmtStationChange,
    sheetUploadError,
    allowedFileExtensions,
    finalFileName,
    handleUpload,
    isUploadBtnInProgress,
  } = props;

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
      fullWidth="true"
    >
      <DialogTitle>
        <Stack direction="row" alignItems="center" gap={0.5} sx={{ my: 0.2 }}>
          <CloudUploadIcon />
          <Typography variant="h6">Upload File</Typography>
        </Stack>
      </DialogTitle>
      <Divider />
      <DialogContent>
        <Stack spacing={2}>
          {title === "Counter movement" ? (
            <>
              {sheetUploadError && sheetUploadError.error ? (
                <Alert severity="error">{sheetUploadError.errorMsg}</Alert>
              ) : (
                <Alert severity="info">
                  Bulk upload for counter movements!
                </Alert>
              )}

              <FormControl size="small" fullWidth>
                <InputLabel id="idStationInputLable">Station</InputLabel>
                <Select
                  labelId="idStationLabelID"
                  id="idStationSelect"
                  value={counterMovementStation}
                  label="Station"
                  onChange={handleCounterMmtStationChange}
                  sx={{
                    "& #idStationSelect": {
                      fontSize: "0.9rem",
                    },
                  }}
                >
                  {counterMovementList?.map((elem, i) => {
                    return (
                      <MenuItem
                        key={i}
                        value={elem.childID}
                        sx={{ fontSize: "1rem" }}
                      >
                        {elem.childName}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </>
          ) : (
            <></>
          )}

          <Paper elevation={2} sx={{ p: "10px" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="file"
                accept={allowedFileExtensions?.join(", ")}
                ref={ref}
                onChange={onChange}
                // className={classes.fileInput}
              />
              {finalFileName && <ClearIcon onClick={clearFileInput} />}
            </Box>
          </Paper>
        </Stack>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"
            component="label"
            onClick={onClose}
            size="small"
            color="error"
          >
            Cancel
          </Button>
          {isUploadBtnInProgress ? (
            <LoadingButton
              loading
              loadingPosition="start"
              startIcon={<UploadIcon />}
              variant="contained"
            >
              Upload
            </LoadingButton>
          ) : (
            <Button
              variant="contained"
              component="label"
              onClick={handleUpload}
              size="small"
              disabled={
                title === "Counter movement" ? sheetUploadError.error : false
              }
            >
              Upload
            </Button>
          )}
        </Stack>
      </DialogActions>
    </Dialog>
  );
});
export default React.memo(PlayerFileUpload);
